import { TableColumn } from "react-data-table-component";
import { IStock } from "../../interfaces/stock.interface";
import moment from "moment";
import { IAttendance } from "../../interfaces/attendance.interface";
import { IDaySale } from "../../interfaces/daysales.interface";
import { totalJuiceCases, totalWaterCases } from "../../utils";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

export const PARTY_DETAILS_COLUMNS: TableColumn<IStock>[] = [
  {
    name: "Stock Date",
    selector: (row: any) => moment(row?.updatedAt).format("DD MMM hh:mm A"),
    sortable: true,
    width: "170px",
  },
  {
    name: "Product Group",
    selector: (row: any) => row?.product?.group,
    sortable: true,
    width: "160px",
  },
  {
    name: "Product",
    selector: (row: any) => row?.product?.name || "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "Volume",
    selector: (row: any) => row?.product?.volume ||'-',
    sortable: true,
    width: "100px",
  },
    {
    name: "Status",
    selector: (row: any) => row?.status ||'-',
    sortable: true,
    width: "140px",
  },
  {
    name: "Total Stock",
    cell: (row: any) => <span>{row?.cases}</span>,
    sortable: true,
    width: "140px",
  },
  {
    name: "Updated By",
    cell: (row: any) => <span>{row?.updatedBy?.fullName}</span>,
    sortable: true,
    width: "130px",
  },
];

export const TIME_DETAILS_COLUMNS: TableColumn<IAttendance>[] = [
  {
    name: "Date",
    selector: (row) => moment(row?.date).format("DD-MM-YYYY"),
    maxWidth: "140px",
  },
  {
    name: "Status",
    selector: (row) => row.status,
    maxWidth: "140px",
  },
  {
    name: "Starting Address",
    selector: (row: any) => row.trips?.startingAddress,
    sortable: true,
    width: "300px",
  },
  {
    name: "Start At",
    selector: (row: any) => moment(row?.trips?.startAt).format("hh:mm A"),
    sortable: true,
    width: "100px",
  },
  {
    name: "Ending Address",
    selector: (row: any) => row.trips?.endingAddress,
    sortable: true,
    width: "300px",
  },
  {
    name: "End At",
    selector: (row: any) => moment(row?.trips?.endAt).format("hh:mm A"),
    sortable: true,
    width: "100px",
  },
  {
    name: "Travel",
    selector: (row: any) => row?.trips?.totalDistance,
    sortable: true,
    width: "200px",
  },
];

export const WORK_DETAILS_COLUMNS: TableColumn<IDaySale>[] = [
  {
    name: "Date",
    selector: (row: any) => moment(row?.addedAt).format("DD MMM hh:mm A"),
    sortable: true,
    width: "130px",
  },
  {
    name: "Shop Name",
    selector: (row: any) => row?.shopName,
    sortable: true,
    width: "160px",
  },
  {
    name: "Owner",
    selector: (row: any) => row?.shopOwner || "-",
    sortable: true,
    width: "160px",
  },
  {
    name: "State",
    selector: (row: any) => row?.shopState,
    sortable: true,
    width: "120px",
  },
  {
    name: "City",
    selector: (row: any) => row?.shopCity,
    sortable: true,
    width: "120px",
  },
  {
    name: "Order Juice",
    selector: (row: any) => totalJuiceCases(row?.sales),
    sortable: true,
    width: "120px",
  },
  {
    name: "Order Water",
    selector: (row: any) => totalWaterCases(row?.sales),
    sortable: true,
    width: "120px",
  },
  {
    name: "Outlet Visit",
    selector: (row: any) => row.sales?.length,
    sortable: true,
    width: "120px",
  },
  {
    name: "Sales",
    selector: (row: any) => row?.totalCases,
    sortable: true,
    width: "80px",
  },
  {
    name: "Travel",
    cell: (row: any) => (
      <Link to={`/trips/${row?.trip}`}>
        <Icon icon="material-symbols:file-map-rounded" fontSize={20} />
      </Link>
    ),
    sortable: true,
    width: "80px",
  },
];
